import {createAction, props} from '@ngrx/store';
import {Event, RollType, Round, Speech, State} from 'gamesis-story-client';
import {TimelineEvent} from './story.model';

export const loadEvents = createAction('[Story] Load Events');
export const loadEventsSuccess = createAction('[Story] Load Events Success', props<{ count: number, events?: Event[] }>());
export const timelineEvent = createAction('[Story] Timeline Event', props<{ event: TimelineEvent }>());
export const timelineCreate = createAction('[Story] Timeline Create', props<{ event: Event, count: number }>());
export const timelineUpdate = createAction('[Story] Timeline Update', props<{ event: Event }>());
export const timelineDelete = createAction('[Story] Timeline Delete', props<{ id: string, count: number }>());
export const initialize = createAction('[Story] Init');
export const synchronize = createAction('[Story] Synchronize');
export const synchronizeSuccess = createAction('[Story] Synchronize Success', props<{ count: number, events: Event[] }>());
export const deleteEvent = createAction('[Story] Delete Event', props<{ id: string }>());
export const deleteEventSuccess = createAction('[Story] Delete Event Success');

export const updateEvent = createAction('[Story] Update Event', props<{ id: string, event: Event }>());
export const deleteActionItem = createAction('[Story] Delete action Item', props<{ event: string, item: string }>());
export const deleteImage = createAction('[Story] Delete image', props<{ id: string }>());
export const addImages = createAction('[Story] Add images', props<{ files: File[], story?: string }>());
export const updateEventSuccess = createAction('[Story] Update Event Success');
export const eventFailure = createAction('[Story] Event Failure', props<{ error: any }>());
export const react = createAction('[Story] React', props<{ id: string, text: string }>());
export const reactSuccess = createAction('[Story] React Success');
export const round = createAction('[Story] Round', props<{ round: Round }>());
export const speak = createAction('[Story] Speak', props<{ speech: Speech, id?: string }>());
export const act = createAction('[Story] Act', props<{ action: string, id?: string }>());
export const comment = createAction('[Story] Comment', props<{ comment: string, id?: string }>());
export const createEventSuccess = createAction('[Story] Create Event Success');
export const rollDice = createAction('[Story] Roll Dice', props<{ text: string, formula: string, rollType: RollType }>());
export const rollStoredDice = createAction('[Story] Roll Stored Dice', props<{ id: string, rollType: string }>());
export const rollSuccess = createAction('[Story] Roll Success');
export const rollFailure = createAction('[Story] Roll Failure');

export const state = createAction('[Story] Character State', props<{ state: State }>());
export const stateUpdate = createAction('[Story] Character State Update', props<{ state: State, character: string }>());
export const stateIdle = createAction('[Story] Character State Idle', props<{ character: string }>());
export const stateError = createAction('[Story] Character State Error');
